var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.4993 32.4062C22.4423 32.4062 15.8848 25.8487 15.8848 17.7916C15.8848 9.7345 22.4423 3.177 30.4993 3.177C38.5564 3.177 45.1139 9.7345 45.1139 17.7916C45.1139 25.8487 38.5564 32.4062 30.4993 32.4062ZM30.4993 6.9895C24.5518 6.9895 19.6973 11.8441 19.6973 17.7916C19.6973 23.7391 24.5518 28.5937 30.4993 28.5937C36.4468 28.5937 41.3014 23.7391 41.3014 17.7916C41.3014 11.8441 36.4468 6.9895 30.4993 6.9895Z",
    fill: "#002C63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.3338 57.8229C51.2917 57.8229 50.4275 56.9588 50.4275 55.9167C50.4275 47.1479 41.4809 40.0313 30.5009 40.0313C19.5209 40.0313 10.5742 47.1479 10.5742 55.9167C10.5742 56.9588 9.71005 57.8229 8.66797 57.8229C7.62589 57.8229 6.76172 56.9588 6.76172 55.9167C6.76172 45.0638 17.4113 36.2188 30.5009 36.2188C43.5905 36.2188 54.24 45.0638 54.24 55.9167C54.24 56.9588 53.3759 57.8229 52.3338 57.8229Z",
    fill: "#002C63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7cbc50b34c29caefeafa4aabb453d161.svg";
export { ForwardRef as ReactComponent };